import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import "../../Styles/pages/transactions.scss";
import "../../Styles/pages/payments.scss";
import "../../Styles/pages/activities.scss";
import "../../Styles/pages/report.scss"
import "../../Styles/pages/dashboard.scss";
import "../../Styles/pages/subscriptionDetail.scss"
import "../../Styles/pages/customers.scss"
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import MembershipActions from "../../Redux/transition/membership/membership.reducer";
import PlanGroupActions from "../../Redux/transition/plan-group/plan-group.reducer";
import PaymentTrackActions from "../../Redux/transition/payment-track/payment-track.reducer";
import PaymentScheduleActions from '../../Redux/transition/payment-schedule/payment-schedule.reducer';
import BusinessCustomersActions from '../../Redux/transition/customers/business-customer.reducer';
import { normalizeSegmentsList } from '../Customers/Segments/segmentUtils';
import { ActionBar } from './actionBar';
import CustomDataTable from "../../Components/CustomDataTable";
import MarkAsPaid from "../../Components/MarkAsPaid";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Paginator } from 'primereact/paginator';
import { useDateFormatter } from "../../Components/FormatDateTime";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { formatTextUppercase, removePlusFromNum } from '../../Components/CleanInputs';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import { getDateRange, resolveLifetimeStart } from '../../Components/DateRange';
import { fetchPaymentsForBcIds, parseBcIdsParam, resolveSubscribersByQuery } from './subscriberSearch';

const PAYMENTS_MOBILE_BREAKPOINT = 1050;
const PAYMENT_FILTER_PARAMS = [
    'product', 'plan', 'segmentId', 'tags', 'searchText', 'bcId', 'bcIds', 'q',
    'membershipId', 'externalMode', 'startDate', 'endDate',
];

// Survives in-app navigation, resets when the browser actually reloads this script.
let paymentReloadFiltersCleared = false;

const pageWasReloaded = () => performance.getEntriesByType('navigation')[0]?.type === 'reload';

const Payments = () => {

    const { formatDate, formatApiDate, formatDateTime } = useDateFormatter();

    const { t } = useTranslation("common");
    const [displayBasic, setDisplayBasic] = useState(false);
    const [calendarDates, setCalendarDates] = useState(null);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [fetchingCsv, setFetchingCsv] = useState(false);
    const [fetchingPdf, setFetchingPdf] = useState(false);
    const [fetchingMissedCsv, setFetchingMissedCsv] = useState(false);
    const [fetchingExternalCsv, setFetchingExternalCsv] = useState(false);
    const [fetchingMissedPdf, setFetchingMissedPdf] = useState(false);
    const [fetchingExternalPdf, setFetchingExternalPdf] = useState(false);
    const [fetchingAccountsCsv, setFetchingAccountsCsv] = useState(false);
    const [fetchingAccountsPdf, setFetchingAccountsPdf] = useState(false);

    const [isMobileStack, setIsMobileStack] = useState(
        () => typeof window !== "undefined" && window.innerWidth <= PAYMENTS_MOBILE_BREAKPOINT
    );
    const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
    const [loadingOverlayTarget, setLoadingOverlayTarget] = useState(null);
    const [overlayContent, setOverlayContent] = useState(null);
    const [overlayTarget, setOverlayTarget] = useState(null);

    const toast = useRef(null);
    const loadingOverlayRef = useRef(null);
    const overlayPanelMoreSubs = useRef(null);
    const hasAppliedTreeSelectionRef = useRef(false);

    const [state, setState] = useState({
        enterpriseCustomers: null,
        businessCustomers: [],
        businessCustomerReports: {},
        invitesData: [],
        paymentsData: [],
        subscriptionsData: [],
        invitationInfo: {},
        paymentsInfo: {},
        subscriptionInfo: {},
        subscriberInfo: {},
        options: null,
        date: null,
        business: {},
        planReports: [],
        planCharts: [],
        planInvitesData: [],
        planSubscriptionsData: [],
        planPaymentsData: [],
        input: '',
        submitInput: false,
        selectedCustomer: null,
        filteredCustomers: [],
        id: null,
        isAmountTrue: null,
        first: 0,
        size: 15,
        paginate: false,
        flex: false,
        allProductsObject: [],
        page: 0,
        trackAttributionsList: [],
        popupClicked: false,
        stateFilteredDataTotals: {},
        stateAccountsTotals: {},
        stateExternalTotals: {},
        treePlanSelected: null,
        treeProductSelected: null,
        treePlanSelectedKey: null
    });

    const { defMembership } = useSelector((state) => state.defMembership)
    const colleagues = useSelector((state) => state.memberships.colleagues)
    const business = useSelector((state) => state.businesses.business)
    const fetchingCollected = useSelector((state) => state.paymentTracks.fetchingCollectedPayments);
    const fetchingMissed = useSelector((state) => state.paymentTracks.fetchingMissedPayments);
    const fetchingExternal = useSelector((state) => state.paymentTracks.fetchingExternalPayments);
    const collectedPayments = useSelector((state) => state.paymentTracks.collectedPaymentTracks);
    const missPayments = useSelector((state) => state.paymentTracks.missedPaymentTracks);
    const externalPayments = useSelector((state) => state.paymentTracks.externalPaymentTracks);
    const planGroupsGraphedActive = useSelector((state) => state.planGroups.planGroupsGraphedActive);
    const planGroupsGraphedAll = useSelector((state) => state.planGroups.planGroupsGraphedAll);
    const allPlanGroups = useSelector((state) => state.planGroups.planGroups);
    const businessCustomerRecord = useSelector((state) => state.businessCustomers.businessCustomerRecord)
    const paymentCsv = useSelector((state) => state.paymentTracks.paymentTracksCsv)
    const paymentPdf = useSelector((state) => state.paymentTracks.paymentTracksPdf)
    const fetchingPaymentCsv = useSelector((state) => state.paymentTracks.fetchingPaymentTracksCsv)
    const fetchingPaymentPdf = useSelector((state) => state.paymentTracks.fetchingPaymentTracksPdf)
    const paymentCsvError = useSelector((state) => state.paymentTracks.errorFetchingPaymentTracksCsv)
    const paymentPdfError = useSelector((state) => state.paymentTracks.errorFetchingPaymentTracksPdf)
    const paymentMissedCsv = useSelector((state) => state.paymentSchedules.paymentMissedCsv)
    const paymentMissedPdf = useSelector((state) => state.paymentSchedules.paymentMissedPdf)
    const fetchingPaymentMissedCsv = useSelector((state) => state.paymentSchedules.fetchingPaymentMissedCsv)
    const fetchingPaymentMissedPdf = useSelector((state) => state.paymentSchedules.fetchingPaymentMissedPdf)
    const paymentMissedCsvError = useSelector((state) => state.paymentSchedules.errorFetchingPaymentMissedCsv)
    const paymentMissedPdfError = useSelector((state) => state.paymentSchedules.errorFetchingPaymentMissedPdf)
    const paymentExternalCsv = useSelector((state) => state.paymentSchedules.paymentExternalCsv)
    const paymentExternalPdf = useSelector((state) => state.paymentSchedules.paymentExternalPdf)
    const fetchingPaymentExternalCsv = useSelector((state) => state.paymentSchedules.fetchingPaymentExternalCsv)
    const fetchingPaymentExternalPdf = useSelector((state) => state.paymentSchedules.fetchingPaymentExternalPdf)
    const paymentExternalCsvError = useSelector((state) => state.paymentSchedules.errorFetchingPaymentExternalCsv)
    const paymentExternalPdfError = useSelector((state) => state.paymentSchedules.errorFetchingPaymentExternalPdf)
    const paymentTrackAttributions = useSelector((state) => state.paymentTracks.paymentAttributions)
    const fetchingPaymentAttributions = useSelector((state) => state.paymentTracks.fetchingPaymentAttributions)
    const { filteredDataTotals, fetchingFilteredDataTotals } = useSelector((state) => state.paymentTracks);
    const { segmentSuccess, tagGroupsGraphed } = useSelector((state) => state.businessCustomers)
    const segmentList = useMemo(() => normalizeSegmentsList(segmentSuccess), [segmentSuccess]);
    const accountsPaymentSearch = useSelector((state) => state.paymentSchedules.accountsPaymentSearch);
    const fetchingAccountsPaymentSearch = useSelector((state) => state.paymentSchedules.fetchingAccountsPaymentSearch);
    const accountsPaymentTotals = useSelector((state) => state.paymentSchedules.accountsPaymentTotals);
    const fetchingAccountsPaymentTotals = useSelector((state) => state.paymentSchedules.fetchingAccountsPaymentTotals);
    const externalPaymentTotals = useSelector((state) => state.paymentSchedules.externalPaymentTotals);
    const fetchingExternalPaymentTotals = useSelector((state) => state.paymentSchedules.fetchingExternalPaymentTotals);
    const accountsPaymentCsv = useSelector((state) => state.paymentSchedules.accountsPaymentCsv);
    const fetchingAccountsPaymentCsv = useSelector((state) => state.paymentSchedules.fetchingAccountsPaymentCsv);
    const accountsPaymentPdf = useSelector((state) => state.paymentSchedules.accountsPaymentPdf);
    const fetchingAccountsPaymentPdf = useSelector((state) => state.paymentSchedules.fetchingAccountsPaymentPdf);

    const dispatch = useDispatch();
    const getMembership = () => dispatch(DefMembershipActions.defMembershipRequest())
    const getActivePlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedActiveRequest(businessId)) }, [dispatch])
    const getCollectedPayments = useCallback((businessId, filter, options) => dispatch(PaymentTrackActions.collectedPaymentTrackRequest(businessId, filter, options)), [dispatch]);
    const getMissedPayments = useCallback((businessId, filter, options) => dispatch(PaymentTrackActions.missedPaymentTrackRequest(businessId, filter, options)), [dispatch]);
    const getExternalPayments = useCallback((businessId, filter, options) => dispatch(PaymentTrackActions.externalPaymentTrackRequest(businessId, filter, options)), [dispatch]);
    const getAllPlanGroups = useCallback((businessId, options) => { dispatch(PlanGroupActions.planGroupAllRequest(businessId, options)) }, [dispatch]);
    const getBusinessCustomerRecord = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.businessCustomerRecordRequest(businessCustomerId)), [dispatch]);
    const getPaymentCsv = useCallback((businessId, membershipId, query, options) => dispatch(PaymentTrackActions.paymentTracksCsvRequest(businessId, membershipId, query, options)), [dispatch]);
    const getPaymentPdf = useCallback((businessId, membershipId, query, options) => dispatch(PaymentTrackActions.paymentTracksPdfRequest(businessId, membershipId, query, options)), [dispatch]);
    const getMissedPaymentCsv = useCallback((businessId, query, options) => dispatch(PaymentScheduleActions.paymentMissedCsvRequest(businessId, query, options)), [dispatch]);
    const getExternalPaymentCsv = useCallback((businessId, query, options) => dispatch(PaymentScheduleActions.paymentExternalCsvRequest(businessId, query, options)), [dispatch]);
    const getMissedPaymentPdf = useCallback((businessId, membershipId, query, options) => dispatch(PaymentScheduleActions.paymentMissedPdfRequest(businessId, membershipId, query, options)), [dispatch]);
    const getExternalPaymentPdf = useCallback((businessId, membershipId, query, options) => dispatch(PaymentScheduleActions.paymentExternalPdfRequest(businessId, membershipId, query, options)), [dispatch]);
    const getPaymentAttributions = useCallback((trackId) => dispatch(PaymentTrackActions.paymentAttributionsRequest(trackId)), [dispatch]);
    const getFilteredDataTotals = useCallback((businessId, filter, options) => dispatch(PaymentTrackActions.filteredDataTotalsRequest(businessId, filter, options)), [dispatch]);
    const getAccountsPayments = useCallback((businessId, filter, options) => dispatch(PaymentScheduleActions.accountsPaymentSearchRequest(businessId, filter, options)), [dispatch]);
    const getAccountsTotals = useCallback((businessId, query, options) => dispatch(PaymentScheduleActions.accountsPaymentTotalsRequest(businessId, query, options)), [dispatch]);
    const getExternalTotals = useCallback((businessId, query, options) => dispatch(PaymentScheduleActions.externalPaymentTotalsRequest(businessId, query, options)), [dispatch]);
    const getAccountsCsv = useCallback((businessId, query, options) => dispatch(PaymentScheduleActions.accountsPaymentCsvRequest(businessId, query, options)), [dispatch]);
    const getAccountsPdf = useCallback((businessId, membershipId, query, options) => dispatch(PaymentScheduleActions.accountsPaymentPdfRequest(businessId, membershipId, query, options)), [dispatch]);
    const getColleagues = useCallback((businessId) => { dispatch(MembershipActions.colleaguesRequest(businessId)) }, [dispatch])

    let doc = []
    const dropdownItems = [
        { name: t("payments.collected"), code: 'CP', alias: "collected", actionType: "FETCH_COLLECTED" },
        { name: t("payments.missed"), code: 'MP', alias: "missed", actionType: "FETCH_MISSED" },
        { name: t("payments.external"), code: 'ER', alias: "external", actionType: "FETCH_EXTERNAL" },
        { name: t("payments.collected_and_external"), code: 'CE', alias: "accounts", actionType: "FETCH_ACCOUNTS" }
    ];

    const dropdownExportItems = [
        { name: t("payments.download_as_pdf"), code: "PDF", alias: t("payments.pdf_hint") },
        { name: t("payments.download_as_csv"), code: "CSV", alias: t("payments.csv_hint") },
    ]

    const exportItemsTemplate = (option) => {
        const handleExportClick = () => {
            if (option?.code === "PDF") {
                getPaymentPdfWithFilters();
            } else {
                getPaymentCsvWithFilters();
            }
        }
        return (
            <section className='flex flex-column mb-1' onClick={() => handleExportClick()}>
                <div className='dropdown-export-temp pt-1'>
                    <p className='m-0 option-name'>{option.name}</p>
                    <i className='pi pi-download' />
                </div>
                <p className='m-0 option-alias'>{option.alias}</p>
            </section>
        )
    }

    const periods = [
        { code: "today", name: "Today" },
        { code: "this_month", name: "This Month" },
        { code: "last_week", name: "Last Week" },
        { code: "last_month", name: "Last Month" },
        { code: "last_3_months", name: "Last 3 Months" },
        { code: "last_6_months", name: "Last 6 Months" },
        { code: "last_12_months", name: "Last 12 Months" },
        { code: "year_to_date", name: "Year to date" },
        { code: "lifetime", name: "Lifetime" },
        { code: "custom", name: "Custom Date" }
    ];

    const defaultTypeOption = dropdownItems[0];
    const defaultProductOption = null;
    const defaultPeriodOption = periods[1];
    const defaultActionType = dropdownItems[0].actionType;

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [typeSelection, setTypeSelection] = useState(defaultTypeOption);
    // eslint-disable-next-line no-unused-vars
    const [productSelection, setProductSelection] = useState(defaultProductOption);
    // eslint-disable-next-line no-unused-vars
    const [planSelection, setPlanSelection] = useState(null);
    const [periodSelection, setPeriodSelection] = useState(defaultPeriodOption);
    const [searchText, setSearchText] = useState('');
    const [bcId, setBcId] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [currentActionType, setCurrentActionType] = useState(defaultActionType);
    // eslint-disable-next-line no-unused-vars
    const [customDate, setCustomDate] = useState('');
    const [showCustomDate, setShowCustomDate] = useState(false);
    const [showSubscriberName, setShowSubscriberName] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [selectionType, setSelectionType] = useState(null);
    const { currencyFormat, currencySymbol } = useCurrencyConstants();
    const [nameCleared, setNameCleared] = useState(false);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [selectedTags, setSelectedTags] = useState(null);
    const [selectedColleague, setSelectedColleague] = useState(null);
    const [selectedExternalMode, setSelectedExternalMode] = useState(null);
    const [pendingSubscriberSearch, setPendingSubscriberSearch] = useState(false);
    const [subscriberNotFound, setSubscriberNotFound] = useState(false);
    const [listRefreshToken, setListRefreshToken] = useState(0);
    const [matchedBcIds, setMatchedBcIds] = useState([]);
    const [subscriberSearchPage, setSubscriberSearchPage] = useState(null);
    const [fetchingSubscriberPayments, setFetchingSubscriberPayments] = useState(false);
    const matchedBcIdsKey = useMemo(() => matchedBcIds.join('|'), [matchedBcIds]);
    const filterStartDate = searchParams.get('startDate');
    const filterEndDate = searchParams.get('endDate');
    const lifetimeStart = useMemo(
        () => resolveLifetimeStart({
            selected: state.treePlanSelected || state.treeProductSelected,
            graphed: planGroupsGraphedAll || planGroupsGraphedActive,
        }),
        [state.treePlanSelected, state.treeProductSelected, planGroupsGraphedAll, planGroupsGraphedActive]
    );
    const searchParamsKey = searchParams.toString();

    const loading = Boolean(
        pendingSubscriberSearch
        || fetchingSubscriberPayments
        || (
            matchedBcIds.length === 0 && (
                typeSelection?.code === "CP"
                    ? (fetchingCollected || fetchingFilteredDataTotals)
                    : typeSelection?.code === "CE"
                        ? (fetchingAccountsPaymentSearch || fetchingAccountsPaymentTotals)
                        : typeSelection?.code === "MP"
                            ? fetchingMissed
                            : (fetchingExternal || fetchingExternalPaymentTotals)
            )
        )
    );


    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${PAYMENTS_MOBILE_BREAKPOINT}px)`);
        const onBreakpointChange = (event) => setIsMobileStack(event.matches);
        onBreakpointChange(mediaQuery);
        mediaQuery.addEventListener("change", onBreakpointChange);
        return () => mediaQuery.removeEventListener("change", onBreakpointChange);
    }, []);

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
        if (defMembership) {
            getActivePlanGroups(defMembership.business.id);
            getAllPlanGroups(defMembership.business.id);
            getColleagues(defMembership.business.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (planGroupsGraphedActive) {
            let planGroupAssigned = Object.assign({}, planGroupsGraphedActive);
            planGroupAssigned.groups.map((item, ind) => {
                const { group } = item;
                doc.push({ ...group });
                return null;
            });
        }
        if (allPlanGroups) {
            setState((state) => { return { ...state, allProductsObject: allPlanGroups } })
        }
        if (business) {
            setState(prev => ({ ...prev, business }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planGroupsGraphedActive, allPlanGroups, business])

    useEffect(() => {
        if (!fetchingFilteredDataTotals && filteredDataTotals) {
            setState((state) => ({
                ...state, stateFilteredDataTotals: filteredDataTotals
            }))
        }
    }, [filteredDataTotals, fetchingFilteredDataTotals])

    useEffect(() => {
        if (!fetchingAccountsPaymentTotals && accountsPaymentTotals) {
            setState((state) => ({
                ...state, stateAccountsTotals: accountsPaymentTotals
            }))
        }
    }, [accountsPaymentTotals, fetchingAccountsPaymentTotals])

    useEffect(() => {
        if (!fetchingExternalPaymentTotals && externalPaymentTotals) {
            setState((state) => ({
                ...state, stateExternalTotals: externalPaymentTotals
            }))
        }
    }, [externalPaymentTotals, fetchingExternalPaymentTotals])

    useEffect(() => {
        if (bcId && !String(bcId).includes('|')) {
            getBusinessCustomerRecord(bcId);
        }
        if (businessCustomerRecord) {
            setState((state) => ({ ...state, subscriberInfo: businessCustomerRecord }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bcId])

    // Restore search field / matched subscriber IDs from URL (bcId only — no q)
    useEffect(() => {
        if (skipStaleReloadFilters.current) return;

        const bcIdFromUrl = searchParams.get('bcId');
        const bcIdsFromUrl = parseBcIdsParam(searchParams.get('bcIds'));

        if (bcIdsFromUrl.length) {
            setMatchedBcIds(bcIdsFromUrl);
            setBcId(bcIdsFromUrl.length === 1 ? bcIdsFromUrl[0] : '');
            return;
        }

        if (bcIdFromUrl) {
            setMatchedBcIds((prev) => (
                prev.length === 1 && String(prev[0]) === String(bcIdFromUrl) ? prev : [bcIdFromUrl]
            ));
            setBcId(bcIdFromUrl);
            if (businessCustomerRecord?.name && String(businessCustomerRecord.id) === String(bcIdFromUrl)) {
                setSearchText((current) => current || businessCustomerRecord.name);
            }
            return;
        }

        setMatchedBcIds((prev) => (prev.length ? [] : prev));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams, businessCustomerRecord])

    useEffect(() => {
        if (nameCleared) {
            const params = new URLSearchParams(searchParams);
            params.delete('bcId')
            params.delete('bcIds')
            params.delete('searchText')
            params.delete('q')
            setSearchParams(params)
            setSearchText('')
            setShowSubscriberName('')
            setBcId('')
            setSubscriberNotFound(false)
            setPendingSubscriberSearch(false)
            setMatchedBcIds([])
            setSubscriberSearchPage(null)
            setState((prev) => ({ ...prev, page: 0, first: 0 }))
            setListRefreshToken((token) => token + 1)
        }
        setNameCleared(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameCleared, searchParams])

    const errorMessage = () => {
        toast.current.show({ severity: 'error', summary: t("failed"), detail: t("payments.csv_error"), life: 5000 });
    }

    useEffect(() => {
        if (fetchingCsv && !fetchingPaymentCsv && paymentCsvError) { errorMessage(); setFetchingCsv(false) }
        if (fetchingPdf && !fetchingPaymentPdf && paymentPdfError) { errorMessage(); setFetchingPdf(false) }
        if (fetchingMissedCsv && !fetchingPaymentMissedCsv && paymentMissedCsvError) { errorMessage(); setFetchingMissedCsv(false) }
        if (fetchingExternalCsv && !fetchingPaymentExternalCsv && paymentExternalCsvError) { errorMessage(); setFetchingExternalCsv(false) }
        if (fetchingMissedPdf && !fetchingPaymentMissedPdf && paymentMissedPdfError) { errorMessage(); setFetchingMissedPdf(false) }
        if (fetchingExternalPdf && !fetchingPaymentExternalPdf && paymentExternalPdfError) { errorMessage(); setFetchingExternalPdf(false) }
        if (fetchingCsv && !fetchingPaymentCsv && paymentCsv) { downloadCsv(paymentCsv, t("payments.collected_csv")); setFetchingCsv(false) }
        if (fetchingPdf && !fetchingPaymentPdf && paymentPdf) { downloadPdf(paymentPdf, t("payments.collected_pdf")); setFetchingPdf(false) }
        if (fetchingMissedCsv && !fetchingPaymentMissedCsv && paymentMissedCsv) { downloadCsv(paymentMissedCsv, t("payments.missed_csv")); setFetchingMissedCsv(false) }
        if (fetchingExternalCsv && !fetchingPaymentExternalCsv && paymentExternalCsv) { downloadCsv(paymentExternalCsv, t("payments.external_csv")); setFetchingExternalCsv(false) }
        if (fetchingMissedPdf && !fetchingPaymentMissedPdf && paymentMissedPdf) { downloadPdf(paymentMissedPdf, t("payments.missed_pdf")); setFetchingMissedPdf(false) }
        if (fetchingExternalPdf && !fetchingPaymentExternalPdf && paymentExternalPdf) { downloadPdf(paymentExternalPdf, t("payments.external_pdf")); setFetchingExternalPdf(false) }
        if (fetchingAccountsCsv && !fetchingAccountsPaymentCsv && accountsPaymentCsv) { downloadCsv(accountsPaymentCsv, 'accounts_payment_report.csv'); setFetchingAccountsCsv(false) }
        if (fetchingAccountsCsv && !fetchingAccountsPaymentCsv && !accountsPaymentCsv) { errorMessage(); setFetchingAccountsCsv(false) }
        if (fetchingAccountsPdf && !fetchingAccountsPaymentPdf && accountsPaymentPdf) { downloadPdf(accountsPaymentPdf, 'accounts_payment_report.pdf'); setFetchingAccountsPdf(false) }
        if (fetchingAccountsPdf && !fetchingAccountsPaymentPdf && !accountsPaymentPdf) { errorMessage(); setFetchingAccountsPdf(false) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchingCsv, fetchingPdf, fetchingMissedCsv, fetchingExternalCsv, fetchingMissedPdf, fetchingExternalPdf, fetchingPaymentCsv, fetchingPaymentPdf, fetchingPaymentMissedCsv, fetchingPaymentExternalCsv, fetchingPaymentExternalPdf, paymentCsv, paymentPdf, paymentMissedCsv, paymentExternalCsv, paymentMissedPdf, paymentExternalPdf, paymentCsvError, paymentPdfError, paymentMissedCsvError, paymentExternalCsvError, paymentMissedPdfError, paymentExternalPdfError, fetchingAccountsCsv, fetchingAccountsPdf, fetchingAccountsPaymentCsv, fetchingAccountsPaymentPdf, accountsPaymentCsv, accountsPaymentPdf]);

    useEffect(() => {
        if (paymentTrackAttributions) {
            const result = paymentTrackAttributions.map(track => ({
                amount: track.amount,
                scheduledFor: formatDate(track.schedule?.scheduledFor)
            }))
            setState((state) => { return { ...state, trackAttributionsList: result } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentTrackAttributions])

    useEffect(() => {
        if (!fetchingPaymentAttributions && overlayTarget && state.popupClicked) {
            loadingOverlayRef.current?.hide();
            setShowLoadingOverlay(false);

            setOverlayContent(
                <div>
                    {(fetchingPaymentAttributions) ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
                    ) : (
                        <div>
                            {state.trackAttributionsList?.map(item => (
                                <div key={item.id} className='attributions-container'>
                                    <div className='attributions-text attributions-flex-text'>{item.scheduledFor}</div>
                                    <FormatCurrency
                                        amount={item?.amount}
                                        currencySymbol={currencySymbol}
                                        currencyFormat={currencyFormat}
                                        className='attributions-text'
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );

            setTimeout(() => {
                if (overlayPanelMoreSubs.current && overlayTarget) {
                    const freshEvent = { currentTarget: overlayTarget, target: overlayTarget };
                    overlayPanelMoreSubs.current.show(freshEvent);
                }
            }, 100);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchingPaymentAttributions, overlayTarget, loadingOverlayTarget, showLoadingOverlay, state.popupClicked]);

    const downloadCsv = (data, filename = 'payment_report.csv') => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const downloadPdf = (pdfResponseString, filename = 'document.pdf') => {
        const blob = new Blob([pdfResponseString], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const getPaymentCsvWithFilters = () => {
        const typeCode = searchParams.get('type') || defaultTypeOption.alias;
        const productCode = searchParams.get('product') || '';
        const planCode = searchParams.get('plan') || '';
        const segmentCode = searchParams.get('segmentId') || '';
        const tagsCode = searchParams.get('tags') || '';
        const startDate = searchParams.get('startDate');
        const endDate = searchParams.get('endDate');
        const text = searchParams.get('searchText') || '';
        const id = searchParams.get('bcId') || '';
        const membershipId = searchParams.get('membershipId') || '';
        const externalMode = searchParams.get('externalMode') || '';

        const params = [];
        if (startDate) params.push(`startDate=${startDate}`);
        if (endDate) params.push(`endDate=${endDate}`);
        if (planCode) {
            params.push(`planId=${planCode}`);
        } else if (productCode) {
            params.push(`groupId=${productCode}`);
        }
        if (segmentCode) params.push(`segmentId=${segmentCode}`);
        if (tagsCode) params.push(`tags=${tagsCode}`);
        if (id) params.push(`bcId=${id}`);
        else if (text) params.push(`searchText=${text}`);
        if (externalMode) params.push(`externalMode=${externalMode}`);

        const queryString = params.join('&');

        if (typeCode === "collected") {
            getPaymentCsv(defMembership.business.id, defMembership.id, queryString);
            setFetchingCsv(true);
        } else if (typeCode === "missed") {
            getMissedPaymentCsv(defMembership.business.id, queryString);
            setFetchingMissedCsv(true);
        } else if (typeCode === "accounts") {
            getAccountsCsv(defMembership.business.id, queryString);
            setFetchingAccountsCsv(true);
        } else {
            const externalQueryParts = [...params];
            if (membershipId) externalQueryParts.push(`recordedById=${encodeURIComponent(membershipId)}`);
            getExternalPaymentCsv(defMembership.business.id, externalQueryParts.join('&'));
            setFetchingExternalCsv(true);
        }
    };

    const getPaymentPdfWithFilters = () => {
        const typeCode = searchParams.get('type') || defaultTypeOption.alias;
        const productCode = searchParams.get('product') || '';
        const planCode = searchParams.get('plan') || '';
        const segmentCode = searchParams.get('segmentId') || '';
        const tagsCode = searchParams.get('tags') || '';
        const startDate = searchParams.get('startDate');
        const endDate = searchParams.get('endDate');
        const text = searchParams.get('searchText') || '';
        const id = searchParams.get('bcId') || '';
        const membershipId = searchParams.get('membershipId') || '';
        const externalMode = searchParams.get('externalMode') || '';

        const params = [];
        if (startDate) params.push(`startDate=${startDate}`);
        if (endDate) params.push(`endDate=${endDate}`);
        if (planCode) {
            params.push(`planId=${planCode}`);
        } else if (productCode) {
            params.push(`groupId=${productCode}`);
        }
        if (id) params.push(`bcId=${id}`);
        else if (text) params.push(`searchText=${text}`);
        if (segmentCode) params.push(`segmentId=${segmentCode}`);
        if (tagsCode) params.push(`tags=${tagsCode}`);

        if (externalMode) params.push(`externalMode=${externalMode}`);

        const queryString = params.join('&');

        if (typeCode === "collected") {
            getPaymentPdf(defMembership.business.id, defMembership.id, queryString, { sort: "receivedAt,desc" });
            setFetchingPdf(true);
        } else if (typeCode === "missed") {
            getMissedPaymentPdf(defMembership.business.id, defMembership.id, queryString, { sort: "scheduledFor,desc" });
            setFetchingMissedPdf(true);
        } else if (typeCode === "accounts") {
            getAccountsPdf(defMembership.business.id, defMembership.id, queryString, { sort: "scheduledFor,desc" });
            setFetchingAccountsPdf(true);
        } else {
            const externalQueryParts = [...params];
            if (membershipId) externalQueryParts.push(`recordedById=${encodeURIComponent(membershipId)}`);
            getExternalPaymentPdf(
                defMembership.business.id,
                defMembership.id,
                externalQueryParts.join('&'),
                { sort: "externallyReceivedOn,desc" }
            );
            setFetchingExternalPdf(true);
        }
    };

    const treeStructure = useMemo(() => {
        const graphedGroupToUse = planGroupsGraphedAll || planGroupsGraphedActive;
        if (!graphedGroupToUse?.groups) return [];

        return graphedGroupToUse.groups.map((groupItem, groupIndex) => {
            const { group, plans } = groupItem;

            const nonArchivedPlans =
                plans?.filter(plan => !plan.status?.includes("ARCHIVED")) || [];

            return {
                key: group?.id != null ? String(group.id) : String(groupIndex),
                label: group.name,
                nodeId: group.id,
                data: group,
                isParent: true,
                selectable: true,
                children: nonArchivedPlans.map((plan, planIndex) => ({
                    key: `${groupIndex}-${planIndex}`,
                    label: plan.name,
                    nodeId: plan.id,
                    data: plan,
                    isParent: false,
                    selectable: true,
                })),
            };
        });
    }, [planGroupsGraphedAll, planGroupsGraphedActive]);

    const tagsOptions = useMemo(() => {
        if (!tagGroupsGraphed?.groups) return [];

        return tagGroupsGraphed.groups
            .filter(group => group?.tags?.length)
            .map(group => ({
                label: group.name,
                items: (group.tags || [])
                    .filter(tag => tag?.id && tag?.name)
                    .map(tag => ({ label: tag.name, value: tag.id }))
            }));
    }, [tagGroupsGraphed]);

    const colleagueListOptions = useMemo(() => {
        if (!colleagues?.length) return [];

        return colleagues.map((colleague) => ({
            label: colleague.user?.name || colleague.name,
            value: String(colleague.id ?? colleague.membershipId),
        }));
    }, [colleagues])

    const selectedColleagueOption = useMemo(() => {
        if (!selectedColleague) return null;
        return colleagueListOptions.find(
            (option) => String(option.value) === String(selectedColleague)
        ) ?? null;
    }, [selectedColleague, colleagueListOptions]);

    const externalModeFilterOptions = useMemo(() => [
        { name: t("payments.external_mode_cash"), code: "CASH" },
        { name: t("payments.external_mode_mobile_money"), code: "MOBILE_MONEY" },
        { name: t("payments.external_mode_bank_transfer"), code: "BANK_TRANSFER" },
        { name: t("payments.external_mode_cheque"), code: "CHEQUE" },
        { name: t("payments.external_mode_unknown"), code: "UNKNOWN" },
    ], [t]);

    const skipStaleReloadFilters = useRef(pageWasReloaded() && !paymentReloadFiltersCleared);

    // A browser refresh drops filters saved in the address and restores the defaults.
    useEffect(() => {
        const params = new URLSearchParams(searchParams);

        if (pageWasReloaded() && !paymentReloadFiltersCleared) {
            paymentReloadFiltersCleared = true;
            skipStaleReloadFilters.current = true;
            PAYMENT_FILTER_PARAMS.forEach((key) => params.delete(key));
            params.set('type', defaultTypeOption.alias);

            const { startDate: defaultStart, endDate: defaultEnd } = getDateRange(
                defaultPeriodOption,
                { returnRange: true }
            );
            params.set('startDate', formatApiDate(defaultStart));
            params.set('endDate', formatApiDate(defaultEnd));
            setPeriodSelection(defaultPeriodOption);
            setShowCustomDate(false);
            setCalendarDates(null);
            setSearchParams(params, { replace: true });
            return;
        }

        skipStaleReloadFilters.current = false;

        if (!params.get('startDate') || !params.get('endDate')) {
            const { startDate: defaultStart, endDate: defaultEnd } = getDateRange(
                defaultPeriodOption,
                { returnRange: true }
            );

            params.set('type', params.get('type') || 'collected');
            params.set('startDate', formatApiDate(defaultStart));
            params.set('endDate', formatApiDate(defaultEnd));
            setSearchParams(params, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    // Keep period dropdown in sync with the URL dates that actually drive the fetch
    useEffect(() => {
        if (skipStaleReloadFilters.current) return;
        if (!filterStartDate || !filterEndDate) return;

        const rangeOptions = { returnRange: true, lifetimeStart };
        const periodMatchesDates = (periodOption) => {
            if (!periodOption || periodOption.code === 'custom') return false;
            const range = getDateRange(periodOption.code, rangeOptions);
            if (!range?.startDate || !range?.endDate) return false;
            return formatApiDate(range.startDate) === filterStartDate && formatApiDate(range.endDate) === filterEndDate;
        };

        if (periodSelection?.code === 'lifetime') {
            if (!lifetimeStart || periodMatchesDates(periodSelection)) {
                setShowCustomDate(false);
                setCalendarDates(null);
            }
            return;
        }

        if (periodMatchesDates(periodSelection)) {
            setShowCustomDate(false);
            setCalendarDates(null);
            return;
        }

        const matchedPeriod = periods.find((periodOption) => periodMatchesDates(periodOption));

        if (matchedPeriod) {
            setPeriodSelection(matchedPeriod);
            setShowCustomDate(false);
            setCalendarDates(null);
            return;
        }

        const customPeriod = periods.find((periodOption) => periodOption.code === 'custom');
        if (customPeriod) {
            setPeriodSelection(customPeriod);
            setShowCustomDate(true);
            setCalendarDates([
                new Date(`${filterStartDate}T00:00:00`),
                new Date(`${filterEndDate}T00:00:00`),
            ]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterStartDate, filterEndDate, lifetimeStart, periodSelection?.code]);

    useEffect(() => {
        if (periodSelection?.code !== 'lifetime' || !lifetimeStart) return;
        const { startDate, endDate } = getDateRange('lifetime', { returnRange: true, lifetimeStart });
        if (!startDate || !endDate) return;
        const nextStart = formatApiDate(startDate);
        const nextEnd = formatApiDate(endDate);
        if (filterStartDate === nextStart && filterEndDate === nextEnd) return;
        const params = new URLSearchParams(searchParams);
        params.set('startDate', nextStart);
        params.set('endDate', nextEnd);
        setSearchParams(params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [periodSelection?.code, lifetimeStart, filterStartDate, filterEndDate]);

    //Main useEffect handling URL updates and expected calls based on URL params change
    useEffect(() => {
        if (skipStaleReloadFilters.current || subscriberNotFound) return;

        const params = new URLSearchParams(window.location.search);
        const type = params.get('type') || 'collected';
        const productId = params.get('product');
        const planId = params.get('plan');
        const text = params.get('searchText');
        const bcIdParam = params.get('bcId');
        const segmentId = params.get('segmentId');
        const tags = params.get('tags');
        const startDate = params.get('startDate');
        const endDate = params.get('endDate');
        const membershipId = params.get('membershipId');
        const externalMode = params.get('externalMode');

        if (!startDate || !endDate) return;

        let queryParams = `?`;
        if (productId) queryParams += `groupId=${productId}&`;
        if (planId) queryParams += `planId=${planId}&`;
        if (segmentId) queryParams += `segmentId=${segmentId}&`;
        if (membershipId) queryParams += `membershipId=${encodeURIComponent(membershipId)}&`;
        if (externalMode) queryParams += `externalMode=${encodeURIComponent(externalMode)}&`;
        if (tags) queryParams += `tags=${tags}&`;
        queryParams += `startDate=${startDate}&endDate=${endDate}`;

        const id = defMembership?.business?.id;
        if (!id) return;

        // Matched subscribers from Payments search: fetch each BCID and merge
        if (matchedBcIds.length > 0) {
            let cancelled = false;
            setFetchingSubscriberPayments(true);
            fetchPaymentsForBcIds({
                businessId: id,
                type,
                baseFilter: queryParams,
                bcIds: matchedBcIds,
                page: state.page,
                size: state.size,
            }).then(({ pageData, totals }) => {
                if (cancelled) return;
                setSubscriberSearchPage(pageData);
                if (type === "collected") {
                    setState((prev) => ({ ...prev, stateFilteredDataTotals: totals }));
                } else if (type === "accounts") {
                    setState((prev) => ({ ...prev, stateAccountsTotals: totals }));
                } else if (type === "external") {
                    setState((prev) => ({ ...prev, stateExternalTotals: totals }));
                }
            }).catch(() => {
                if (cancelled) return;
                setSubscriberSearchPage({ content: [], totalElements: 0 });
            }).finally(() => {
                setFetchingSubscriberPayments(false);
            });
            return () => { cancelled = true; };
        }

        setFetchingSubscriberPayments(false);
        setSubscriberSearchPage(null);

        if (bcIdParam) {
            queryParams += `&bcId=${encodeURIComponent(bcIdParam)}`;
            setBcId((prev) => (String(prev) === String(bcIdParam) ? prev : bcIdParam));
        } else {
            setBcId((prev) => (prev ? '' : prev));
            if (text) queryParams += `&searchText=${encodeURIComponent(text)}`;
        }

        const collectedPaginationParams = {
            page: state.page,
            size: state.size,
            sort: "receivedAt,desc"
        };
        const paginationParams = {
            page: state.page,
            size: state.size,
            sort: "scheduledFor,desc"
        };
        const externalPaginationParams = {
            page: state.page,
            size: state.size,
            sort: "externallyReceivedOn,desc"
        };

        switch (type) {
            case "collected":
                getCollectedPayments(id, queryParams, collectedPaginationParams);
                getFilteredDataTotals(id, queryParams, collectedPaginationParams);
                break;
            case "accounts":
                const accountsQueryParams = `${queryParams}&sort=scheduledFor,desc`;
                const accountsPaginationParams = {
                    page: state.page,
                    size: state.size,
                };
                getAccountsPayments(id, accountsQueryParams, accountsPaginationParams);
                getAccountsTotals(id, queryParams, accountsPaginationParams);
                break;
            case "FETCH_MISSED":
            case "missed":
                getMissedPayments(id, queryParams, paginationParams);
                break;
            case "external":
                getExternalPayments(id, queryParams, externalPaginationParams);
                getExternalTotals(id, queryParams, externalPaginationParams);
                break;
            default:
                getExternalPayments(id, queryParams, externalPaginationParams);
                break;
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParamsKey, state.page, state.size, defMembership?.business?.id, subscriberNotFound, listRefreshToken, matchedBcIdsKey]);

    //Store variables via URL data
    useEffect(() => {
        if (skipStaleReloadFilters.current) return;

        const type = searchParams.get('type') || 'collected';
        const productId = searchParams.get('product');
        const planId = searchParams.get('plan');
        const text = searchParams.get('searchText');
        const segmentId = searchParams.get('segmentId');
        const tags = searchParams.get('tags');
        const membershipId = searchParams.get('membershipId');
        const externalMode = searchParams.get('externalMode');

        if (type) {
            const findType = dropdownItems.find(i => String(i.alias) === String(type))
            setTypeSelection(findType);
        }

        if (text) {
            setSearchText(text)
        }

        if (segmentId) {
            const chosenSegment = segmentList.find(
                i => String(i.id) === String(segmentId)
            );
            setSelectedSegment(chosenSegment);
        } else setSelectedSegment(null);

        if (productId) {
            const chosenProduct = treeStructure.find(i =>
                String(i.data?.id) === String(productId) || String(i.key) === String(productId) || String(i.nodeId) === String(productId)
            );
            const prefillProduct = location.state?.prefillProduct;
            const productFromNav = prefillProduct && String(prefillProduct.id) === String(productId)
                ? prefillProduct
                : null;
            const productData = chosenProduct?.data || productFromNav;
            const nextKey = chosenProduct?.key != null ? String(chosenProduct.key) : String(productId);

            setState((prev) => {
                if (
                    String(prev.treeProductSelected?.id) === String(productData?.id || productId)
                    && String(prev.treePlanSelectedKey) === nextKey
                    && !prev.treePlanSelected
                ) {
                    return prev;
                }
                return {
                    ...prev,
                    treeProductSelected: productData || prev.treeProductSelected,
                    treePlanSelected: null,
                    treePlanSelectedKey: nextKey,
                };
            });
        }

        if (planId) {
            const chosenPlan = treeStructure
                .flatMap(i => i.children || [])
                .find(child => String(child.nodeId) === String(planId) || String(child.key) === String(planId));
            if (chosenPlan) {
                setState((prev) => {
                    if (
                        String(prev.treePlanSelected?.id) === String(chosenPlan.data?.id)
                        && String(prev.treePlanSelectedKey) === String(chosenPlan.key)
                        && !prev.treeProductSelected
                    ) {
                        return prev;
                    }
                    return {
                        ...prev,
                        treePlanSelected: chosenPlan.data,
                        treeProductSelected: null,
                        treePlanSelectedKey: String(chosenPlan.key),
                    };
                });
            }
        }

        if (tags) {
            const arrayedTags = tags.split("|").map(Number);
            setSelectedTags(arrayedTags)
        }

        if (membershipId) {
            setSelectedColleague(String(membershipId));
        } else {
            setSelectedColleague(null);
        }

        if (externalMode) {
            const chosenExternalMode = externalModeFilterOptions.find(
                (option) => option.code === externalMode
            );
            setSelectedExternalMode(chosenExternalMode || null);
        } else {
            setSelectedExternalMode(null);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams, colleagueListOptions, treeStructure, location.state])

    // TYPE CHANGE
    const handleTypeChange = (e) => {
        const selectedOption = e.value;
        setTypeSelection(selectedOption);
        const params = new URLSearchParams(window.location.search);
        params.set('type', selectedOption.alias);
        if (selectedOption.code !== 'ER') {
            params.delete('membershipId');
            params.delete('externalMode');
            setSelectedColleague(null);
            setSelectedExternalMode(null);
        }
        setSearchParams(params);
    };

    // Typing only updates local query; selecting a suggestion applies BCID
    const handleSearchChange = (e) => {
        const value = e?.value ?? e?.target?.value ?? '';
        if (value && typeof value === 'object') {
            setSearchText(value.name || '');
            return;
        }

        const next = String(value ?? '');
        const currentQuery = typeof searchText === 'string' ? searchText : (searchText?.name || '');
        if (next === currentQuery || (showSubscriberName && next === showSubscriberName)) return;

        const params = new URLSearchParams(window.location.search);
        const hadActiveSubscriberFilter = Boolean(
            subscriberNotFound
            || matchedBcIds.length
            || showSubscriberName
            || params.has('bcId')
            || params.has('bcIds')
            || params.has('searchText')
            || params.has('q')
        );

        setSearchText(value);
        setSubscriberNotFound(false);
        setMatchedBcIds([]);
        setSubscriberSearchPage(null);

        if (params.has('bcId') || params.has('bcIds') || params.has('searchText') || params.has('q') || showSubscriberName) {
            params.delete('bcId');
            params.delete('bcIds');
            params.delete('searchText');
            params.delete('q');
            setSearchParams(params);
            setBcId('');
            setShowSubscriberName('');
        } else if (hadActiveSubscriberFilter) {
            // Leave empty "not found" state and reload the unfiltered list
            setListRefreshToken((token) => token + 1);
        }
    };

    const handleSearchSubmit = async (submittedValue) => {
        const fromField = typeof submittedValue === 'string' ? submittedValue : '';
        const currentQuery = (typeof searchText === 'string' ? searchText : searchText?.name) || showSubscriberName || '';
        const query = fromField.trim() || currentQuery;
        const normalizedQuery = String(query).trim();
        if (normalizedQuery.length < 3 || !defMembership?.business?.id || pendingSubscriberSearch) {
            return;
        }

        const repeatOfCurrent = matchedBcIds.length > 0 && (
            normalizedQuery.toLowerCase() === String(currentQuery).trim().toLowerCase()
            || normalizedQuery.toLowerCase() === String(showSubscriberName || '').trim().toLowerCase()
        );

        setState((prev) => ({ ...prev, page: 0, first: 0 }));
        setSubscriberNotFound(false);
        setPendingSubscriberSearch(true);
        setSearchText(normalizedQuery);

        try {
            const { matches, bcIds, bcIdsParam } = await resolveSubscribersByQuery(defMembership.business.id, normalizedQuery);

            if (!bcIds.length || !matches.length) {
                setSearchText(normalizedQuery);
                if (repeatOfCurrent) return;

                setSubscriberNotFound(true);
                setMatchedBcIds([]);
                setBcId('');
                setShowSubscriberName('');
                const params = new URLSearchParams(window.location.search);
                params.delete('bcId');
                params.delete('bcIds');
                params.delete('searchText');
                params.delete('q');
                setSearchParams(params);
                return;
            }

            const nextKey = bcIds.map(String).join('|');
            const sameCustomers = nextKey === matchedBcIdsKey;

            setSubscriberNotFound(false);
            setSearchText(normalizedQuery);
            setShowSubscriberName('');
            setMatchedBcIds(bcIds);
            setBcId(bcIds.length === 1 ? bcIds[0] : '');

            const params = new URLSearchParams(window.location.search);
            params.delete('searchText');
            params.delete('q');
            if (bcIds.length === 1) {
                params.set('bcId', String(bcIds[0]));
                params.delete('bcIds');
            } else {
                params.set('bcIds', bcIdsParam);
                params.delete('bcId');
            }
            setSearchParams(params);
            if (sameCustomers) {
                setListRefreshToken((token) => token + 1);
            }
        } catch (error) {
            setSearchText(normalizedQuery);
            if (repeatOfCurrent) return;

            setSubscriberNotFound(true);
            setMatchedBcIds([]);
            setBcId('');
            setShowSubscriberName('');
        } finally {
            setPendingSubscriberSearch(false);
        }
    };

    // SEGMENT CHANGE
    const handleSegmentFilter = (e) => {
        const value = e.value
        const params = new URLSearchParams(window.location.search);
        if (value?.id) params.set('segmentId', value.id);
        else params.delete('segmentId');
        setSearchParams(params);
    };

    //TAGS CHANGE
    const handleTagSelection = (e) => {
        const tags = e.value;
        setSelectedTags(tags);

        const params = new URLSearchParams(searchParams);
        if (tags && tags.length > 0) {
            params.set('tags', tags.join('|'));
        } else {
            params.delete('tags');
        }

        setSearchParams(params);
    };

    //COLLEAGUE SELECTION
    const handleColleagueSelect = (e) => {
        const val = e?.value;
        const normalizedVal = val != null && val !== '' ? String(val) : null;
        setSelectedColleague(normalizedVal);

        const params = new URLSearchParams(window.location.search);
        if (normalizedVal) params.set('membershipId', normalizedVal);
        else params.delete('membershipId');

        setSearchParams(params);
    }

    const handleExternalModeSelect = (e) => {
        const val = e?.value;
        setSelectedExternalMode(val);

        const params = new URLSearchParams(window.location.search);
        if (val?.code) params.set('externalMode', val.code);
        else params.delete('externalMode');

        setSearchParams(params);
    }

    // PERIOD CHANGE
    const handlePeriodChange = (selectedPeriod) => {
        const periodValue = selectedPeriod.value;
        setPeriodSelection(periodValue);
        const params = new URLSearchParams(window.location.search);

        if (periodValue.code === 'custom') {
            setShowCustomDate(true);
            setCalendarVisible(true);
            return;
        } else {
            setShowCustomDate(false);
            setCalendarVisible(false);
            setCalendarDates(null);
            setCustomDate('');
        }

        const { startDate: chosenStart, endDate: chosenEnd } = getDateRange(
            periodValue.code,
            { returnRange: true, lifetimeStart }
        );
        if (!chosenStart || !chosenEnd) return;
        params.set('startDate', formatApiDate(chosenStart));
        params.set('endDate', formatApiDate(chosenEnd));

        setSearchParams(params);
    };

    // CALENDAR SELECT (for custom period)
    const handleCalendarSelect = (e) => {
        const value = e.value;
        setCalendarDates(value);

        if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
            const customStartDate = formatApiDate(value[0]);
            const customEndDate = formatApiDate(value[1]);

            const displayValue = `${customStartDate} - ${customEndDate}`;

            setCustomDate(displayValue);
            setCalendarVisible(false);

            const params = new URLSearchParams(searchParams);
            params.set('startDate', customStartDate);
            params.set('endDate', customEndDate);

            setSearchParams(params);
        }
    };

    //function to clear custom dates
    const onClearButtonClick = () => {
        const params = new URLSearchParams(window.location.search);

        const { startDate: defaultStart, endDate: defaultEnd } = getDateRange(
            defaultPeriodOption,
            { returnRange: true }
        );

        params.set('startDate', formatApiDate(defaultStart));
        params.set('endDate', formatApiDate(defaultEnd));

        setSearchParams(params);

        setPeriodSelection(defaultPeriodOption);
        setShowCustomDate(false);
        setCalendarVisible(false);
        setCalendarDates(null);
        setCustomDate('');
    }

    useEffect(() => {
        if (state.treePlanSelectedKey != null && state.treePlanSelectedKey !== '') {
            hasAppliedTreeSelectionRef.current = true;
        }
    }, [state.treePlanSelectedKey]);

    // Keep the product/plan query in sync with TreeSelect, without wiping incoming URL filters on mount
    useEffect(() => {
        const params = new URLSearchParams(searchParams);
        const selectedPlan = state.treePlanSelected;
        const selectedProduct = state.treeProductSelected;
        const selectedKey = state.treePlanSelectedKey;
        const selectedKeyIsProduct = selectedKey != null && selectedKey !== '' && !String(selectedKey).includes('-');
        const hasSelection = Boolean(selectedPlan?.id || selectedProduct?.id || selectedKeyIsProduct);
        const urlHasFilter = Boolean(params.get('product') || params.get('plan'));

        if (!hasSelection && urlHasFilter && (
            !hasAppliedTreeSelectionRef.current || state.treePlanSelectedKey != null
        )) {
            return;
        }

        if (selectedPlan?.id) {
            params.set('plan', selectedPlan.id);
            params.delete('product');
        } else if (!selectedPlan) {
            params.delete('plan');
        }
        if (selectedProduct?.id) {
            params.set('product', selectedProduct.id);
            params.delete('plan');
        } else if (selectedKeyIsProduct) {
            params.set('product', selectedKey);
            params.delete('plan');
        } else {
            params.delete('product');
        }

        if (params.toString() !== searchParams.toString()) {
            setSearchParams(params);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.treePlanSelected, state.treeProductSelected, state.treePlanSelectedKey]);


    const statusTemplate = (rowData, e) => {
        return rowData && <span className={`product-badge status-${rowData ? rowData.toLowerCase() : ""}`}>{rowData}</span>;
    };

    const handleOverlay = (e, id) => {
        e.stopPropagation();
        const targetElement = e.currentTarget;
        setLoadingOverlayTarget(targetElement);
        setShowLoadingOverlay(true);
        loadingOverlayRef.current?.show(e);
        setOverlayContent(null);
        setOverlayTarget(targetElement);
        setState((prevState) => ({ ...prevState, popupClicked: true }));
        getPaymentAttributions(id);
    };

    const hideCustomerSubscriptions = () => {
        setOverlayContent(null);
        setOverlayTarget(null);
        setState((prevState) => ({ ...prevState, popupClicked: false }));
        setState((state) => { return { ...state, trackAttributionsList: [] } });
    };

    const today = new Date();
    const todayDate = formatDateTime(today)
    const endDates = formatDateTime(defMembership.joinedOn)
    const currency = defMembership.business?.currency;

    const markActionTemplate = (rowData) => {
        if (rowData) {
            return (rowData.subscriptionStatus === "ACTIVE" ? <Button
                label={t("subscriber.paid")}
                style={{ color: (defMembership.role !== "VIEWER") ? "#008dd5" : '#6c757d' }}
                className="p-button-warning p-button-rounded p-button-text mr-2 customerAction"
                onClick={() => {
                    if (defMembership.role !== "VIEWER") {
                        setDisplayBasic(true)
                        setState((state) => ({
                            ...state,
                            id: rowData.id,
                            flex: rowData.flex,
                            scheduledDate: rowData.scheduledDate
                        }));
                    }
                }}
            /> : "")
        }
    }

    const subscriptionBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div className='text-left cursor-pointer mb-2' onClick={() => navigate(`/crm/customers/customer/subscription/${rowData.subscriptionId}`)}>
                    {rowData.subscriptionRef ? <p className="detail-navigation space-beneath" id="sub_ref">  {rowData.subscriptionRef} </p> : null}
                    <div className="flex" style={{ paddingBottom: "0.2rem" }}>
                        {rowData.deductionPolicy === "TARGET" ?
                            (<>
                                <p className="text-left policy mb-0 mr-2">{t('billing', { val: rowData.deductionPolicy })}</p>
                                <p className="text-left policy target-stat mb-0 mr-1">{rowData.targetEqualParts ? t("product.equal") : t("product.varying")}</p>
                                {(rowData.targetEqualParts && rowData.recoverMissed) && <p className="text-left policy target-stat-miss mb-0">{t('product.recovery')}</p>}
                            </>) :
                            <p className="text-left policy mb-0">{rowData.deductionPolicy === "FIXED" ? t("products.fixed_billing").toUpperCase() : rowData.deductionPolicy === "CUSTOM" ? t("products.custom_billing").toUpperCase() : t('billing', { val: rowData.deductionPolicy })}</p>
                        }
                    </div>
                    {rowData.planName ? <p className="plan-group-text plan_name space-beneath">{rowData.planName}</p> : null}
                </div>
                {rowData.customerNum && (rowData.busCustomerName || rowData.customerName) ?
                    <div>
                        <p className="text-left cus-text space-beneath"> {rowData.customerNum}</p>
                        <p className="ref-text text-left space-beneath" id='tierSub'> {rowData.busCustomerName || rowData.customerName}</p>
                    </div>
                    : !rowData.customerNum && (rowData.busCustomerName || rowData.customerName) ?
                        <p className="text-left cus-text space-beneath">{rowData.busCustomerName || rowData.customerName}</p> : null
                }
                {rowData.phoneNo ? <span className="ref-text" id='tierSub'>{removePlusFromNum(rowData.phoneNo)} </span> : null}
                {rowData.segmentName ?
                    <span className="text-xs segment-tag-div">{rowData.segmentName} </span> : null
                }
                {
                    Array.isArray(rowData.tags) && rowData.tags.length > 0 &&
                    <section className='flex gap-1'>
                        {rowData.tags.map((tag, index) => (
                            <div key={tag.id ?? tag.name ?? index} className='text-left tag-div-main tag-class mt-1'>
                                {tag.name}
                            </div>
                        ))}
                    </section>
                }
            </div>
        }
    }

    const paymentIdBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                {(typeSelection.code === "CP" || typeSelection.code === "CE") ?
                    <div>
                        {rowData.reference ? <p className="detail-navigation paymentID" id="paymentId"
                            onClick={() => navigate(`/payments/detail/${rowData.id}`)}>
                            {rowData.reference}
                        </p> : rowData.id ? <p className="detail-navigation paymentID" id="paymentId">
                            {rowData.id}
                        </p> :
                            "--"}
                        {typeSelection.code === "CE" && (
                            <span className={rowData.externallyReceivedOn ? 'payment-type-badge badge-external' : 'payment-type-badge badge-collected'}>
                                {rowData.externallyReceivedOn ? 'EXTERNAL' : 'COLLECTED'}
                            </span>
                        )}
                    </div>
                    : typeSelection.code === "MP" ?
                        <div id="payments-subscriptionBodyTemplate">
                            {rowData.status ? <p className="plan-group-text status-EXPIRED">{rowData.status}</p> : null}
                            <span className="cust-scheduledFor mb-2">{t("payments.schedule_for")}</span>
                            {rowData.scheduledFor && <p className='scheduledFor mt-2'>{formatDateTime(rowData.scheduledFor)}</p>}
                        </div> :
                        <div>{rowData.id ? <p className="detail-navigatio" id="transactionId"> {rowData.id}</p> : null}</div>
                }
            </div>
        }
    }

    const providerFeeTemplate = (rowData) => {
        if (rowData) {
            return <div>
                {!rowData.feesPassedOn ? <FormatCurrency amount={rowData.providerFees} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='detail-navigatio feePayment' id='fees' /> :
                    <FormatCurrency amount={0.00} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='detail-navigatio feePayment' id='fees' />}
            </div>
        }
    }

    const paymentDetsBodyTemplate = (rowData, e) => {
        if (rowData) {
            const paymentDetailsDate = typeSelection.code === "CE"
                ? rowData.scheduledFor
                : (rowData.receivedAt || rowData.externallyReceivedOn || rowData.scheduledFor);

            return <div>
                {(typeSelection.code === "CP" || typeSelection.code === "CE") ?
                    <div>{paymentDetailsDate ?
                        <div className="detail-navigatio text-left flex flex-column" id="cp-occured">
                            <span className='date-time'>{formatDateTime(paymentDetailsDate)}</span>
                            {(rowData.paymentModeName && rowData.paymentMode) && <div className='flex mt-1'>
                                <p className='pay-style mb-0'>{rowData.paymentMode}</p>
                                <p className='pay-style mb-0 mr-2 ml-2'>|</p>
                                <p className='pay-style mb-0'>{rowData.paymentModeName}</p>
                            </div>}
                            {rowData.paymentIdentifier && <span className='phone-detail mt-1'>{rowData.paymentIdentifier?.startsWith("+") ? removePlusFromNum(rowData.paymentIdentifier) : rowData.paymentIdentifier}</span>}
                        </div> : '--'
                    }</div>
                    : typeSelection.code === "MP" ?
                        <div>{rowData.status ? statusTemplate(rowData.status, e) : "--"}</div> :
                        <div>{rowData.externallyReceivedOn ?
                            <div className="detail-navigatio" id="occured">
                                <span className='date-time'>{formatDate(rowData.externallyReceivedOn)}</span>
                                {rowData.extReceivedMode && <p className='pay-style m-0'>
                                    {formatTextUppercase(rowData.extReceivedMode)}
                                </p>}
                                <p className='phone-detail mt-0'>{rowData.extReceivedRef}</p>
                            </div> : '--'
                        }</div>
                }
            </div>
        }
    }

    const colAmountBodyTemplate = (rowData, e) => {
        if (rowData) {
            return <>
                {(typeSelection.code === "CP" || typeSelection.code === "CE") ?
                    <div>
                        {rowData.amount ?
                            <div className="col_amounts">
                                <FormatCurrency amount={rowData.amount} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='firstPayment' />
                                {typeSelection.code === "CP" && rowData.setupFee !== null ?
                                    <div>
                                        <div style={{ display: "flex" }}>
                                            <div className="mb-1">
                                                <span style={{ color: "#000", fontWeight: "bold", fontSize: "12px" }}>{t("subscriber.amount")}:</span>
                                                <FormatCurrency amount={rowData.originalAmount} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='original-amount' />
                                            </div>
                                        </div>
                                        <div className="setup_fee_div" id="setup-m-b">
                                            <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                                            <FormatCurrency amount={rowData.setupFee} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='setup_fee_value' />
                                        </div>
                                    </div> : ""
                                }
                                {(rowData.recoverMissed === true && rowData.recoveries > 0 && rowData.recoveryIds !== "") &&
                                    <span className='attributions hover_name' onClick={(e) => { setOverlayContent(true); handleOverlay(e, rowData.id) }}>{t("common.payment_list")}</span>
                                }
                            </div> : null}
                    </div> :
                    <div className="col_amount_body">
                        {rowData.flex === true ?
                            <div>
                                <span style={{ display: "block", marginBottom: "0.5rem" }}>{t("products.flexible_amount")}</span>
                                {rowData.amount && <FormatCurrency amount={rowData.amount} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='transactions_data' />}
                            </div> :
                            <div>
                                {rowData.amount ? <FormatCurrency amount={rowData.amount} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='transactions_data' /> : null}
                            </div>
                        }
                    </div>
                }
            </>
        }
    }

    const feesBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                {typeSelection.code === "CP" ?
                    <div className="fees_template">{rowData.fees ? <FormatCurrency amount={rowData.fees} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='detail-navigatio feePayment' id='fees' /> : null}</div>
                    : typeSelection.code === "CE" ?
                        <div className="notes_template">{rowData.extReceivedNotes ? <p className="detail-navigatio" id="fees"> {rowData.extReceivedNotes} </p> : '--'}</div>
                        : typeSelection.code === "MP" ?
                            <div className="fees_template">{rowData.flex === true ? t("products.flexible_amount") : rowData.amount ? <FormatCurrency amount={rowData.amount} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='transactions_data' /> : '--'}</div>
                            : <>
                                <div className="notes_template">{rowData.extReceivedNotes ? <p className="detail-navigatio" id="fees"> {rowData.extReceivedNotes} </p> : '--'}</div>
                            </>
                }
            </div>
        }
    }

    const redeemableBodyTemplate = (rowData) => {
        if (rowData) {
            return <>
                {typeSelection.code === "CP" ?
                    <div className="inv_revenue_template">{rowData.redeemable ? <FormatCurrency amount={rowData.redeemable} currencySymbol={currencySymbol} currencyFormat={currencyFormat} className='detail-navigatio revenue' id='redeemable' /> : null}</div>
                    : typeSelection.code === 'MP' &&
                    <div className="mark-action-template">{rowData.subscriptionStatus === 'ACTIVE' ? markActionTemplate(rowData) : null}</div>
                }
            </>
        }
    }

    const paymentsMobileSummaryTemplate = (rowData) => (
        <div className="payments-mobile-summary">
            <div className="payments-mobile-section">
                {paymentIdBodyTemplate(rowData)}
            </div>
            <div className="payments-mobile-section">
                {subscriptionBodyTemplate(rowData)}
            </div>
            {typeSelection.code !== "MP" && (
                <div className="payments-mobile-section">
                    {paymentDetsBodyTemplate(rowData)}
                </div>
            )}
            <div className="payments-mobile-section">
                {colAmountBodyTemplate(rowData)}
            </div>
            {typeSelection.code !== "MP" && (
                <div className="payments-mobile-section">
                    {feesBodyTemplate(rowData)}
                </div>
            )}
            {typeSelection.code === "CP" && (
                <div className="payments-mobile-section">
                    {providerFeeTemplate(rowData)}
                </div>
            )}
            {(typeSelection.code === "CP" || typeSelection.code === "MP") && (
                <div className="payments-mobile-section payments-mobile-section-last">
                    {redeemableBodyTemplate(rowData)}
                </div>
            )}
        </div>
    );

    const desktopColumns = [
        {
            field: "reference",
            header: (typeSelection.code === "CP" || typeSelection.code === "CE") ? t("payments.payment_id") : typeSelection.code === "MP" ? t("products.payment_schedule") : t("payments.transaction_id"),
            className: (typeSelection.code === "CP" || typeSelection.code === "CE") ? "payment-id" : typeSelection.code === "MP" ? "tier-info" : "trans-id",
            body: paymentIdBodyTemplate,
            alignHeader: "left"
        },
        {
            field: "customerNum",
            header: (typeSelection.code === "CP" || typeSelection.code === "CE") ? t("payments.subscription_info") : typeSelection.code === "MP" ? t("subscriber.info") : t("payments.subscription_info"),
            className: (typeSelection.code === "CP" || typeSelection.code === "CE") ? "colPaymentBodyTemplate" : "paymentSubsBodyTemplate",
            alignHeader: "left",
            body: subscriptionBodyTemplate,
        },
        {
            field: "receivedAt",
            header: (typeSelection.code === "CP" || typeSelection.code === "CE") ? t("payments.payment-dets") : typeSelection.code === "MP" ? null : t("payments.payment-dets"),
            className: (typeSelection.code === "CP" || typeSelection.code === "CE") ? "col-occurred-on" : typeSelection.code === "MP" ? "schedule-status-payments" : "occurred-on",
            body: typeSelection.code === "MP" ? null : paymentDetsBodyTemplate,
            alignHeader: "left",
            sort: !(["ER", "MP"].includes(typeSelection?.code)) && true,
        },
        {
            field: "amount",
            header: (typeSelection.code === "CP" || typeSelection.code === "CE") ? t("payments.collect") : t("payments.amount"),
            body: colAmountBodyTemplate,
            alignHeader: "left",
            sort: true
        },
        {
            field: "fees",
            header: typeSelection.code === "CP" ? t("payments.service_fees") : typeSelection.code === "CE" ? t("payments.note") : typeSelection.code === "MP" ? null : t("payments.note"),
            body: typeSelection.code === "MP" ? null : feesBodyTemplate,
            sortable: !(["ER", "MP", "CE"].includes(typeSelection?.code)) && true,
            alignHeader: "left"
        },
        {
            field: "providerFees",
            header: typeSelection.code === "CP" ? t("payments.transaction_fees") : null,
            body: typeSelection.code === "CP" ? providerFeeTemplate : null,
            sortable: !(["ER", "MP"].includes(typeSelection?.code)) && true,
            alignHeader: "left"
        }
    ];

    if (typeSelection.code !== "ER" && typeSelection.code !== "CE") {
        desktopColumns.push({
            field: "redeemable",
            className: typeSelection.code === "MP" || typeSelection.code === "CP" ? "revenue" : 'no-revenue',
            header: typeSelection.code === 'CP' && t("payments.revenue"),
            body: redeemableBodyTemplate,
            sort: typeSelection.code === 'CP' && true,
            alignHeader: "left"
        });
    }

    const mobileSummaryColumn = {
        field: "mobileSummary",
        header: t("payments.payment_id"),
        body: paymentsMobileSummaryTemplate,
        className: "payments-mobile-summary-column",
    };

    const columns = isMobileStack ? [mobileSummaryColumn] : desktopColumns;


    const paymentRows = subscriberNotFound
        ? []
        : matchedBcIds.length > 0
            ? (subscriberSearchPage?.content ?? [])
            : typeSelection.code === "CP"
                ? collectedPayments?.content
                : typeSelection.code === "CE"
                    ? accountsPaymentSearch?.content
                    : typeSelection.code === "MP"
                        ? missPayments?.content
                        : externalPayments?.content;

    const totalRecords = subscriberNotFound
        ? 0
        : matchedBcIds.length > 0
            ? (subscriberSearchPage?.totalElements ?? 0)
            : typeSelection.code === "CP"
                ? collectedPayments?.totalElements
                : typeSelection.code === "CE"
                    ? accountsPaymentSearch?.totalElements
                    : typeSelection.code === "MP"
                        ? missPayments?.totalElements
                        : externalPayments?.totalElements;

    const onPageChange = (e) => {
        if (e.pageCount <= 1) return;
        setState((state) => ({ ...state, first: e.first, page: e.page }));
    }

    const spinnerConditions = fetchingPaymentPdf || fetchingPaymentMissedPdf || fetchingPaymentExternalPdf || fetchingPaymentCsv || fetchingPaymentMissedCsv || fetchingPaymentExternalCsv || fetchingAccountsPaymentCsv || fetchingAccountsPaymentPdf;

    return (
        <div className='payments-screen'>
            <Toast ref={toast} />
            <MarkAsPaid displayDialog={displayBasic} onHide={() => { setDisplayBasic(false) }}
                scheduleId={state.id}
                isFlexTrue={state.flex}
                scheduledDate={state.scheduledDate}
                callbackFunctions={() => {
                    getCollectedPayments(defMembership.business.id, `?startDate=${endDates}&endDate=${todayDate}`, { sort: "receivedAt,desc" });
                    getMissedPayments(defMembership.business.id, `?startDate=${endDates}&endDate=${todayDate}`, { sort: "scheduledFor,desc" });
                    getExternalPayments(defMembership.business.id, `?startDate=${endDates}&endDate=${todayDate}`, { sort: "externallyReceivedOn,desc" });
                }} />
            <ActionBar
                typeSelection={typeSelection}
                setSelectedType={handleTypeChange}
                dropdownItems={dropdownItems}
                selectedCustomer={searchText}
                setSelectedCustomer={handleSearchChange}
                onSearchSubmit={handleSearchSubmit}
                onClear={onClearButtonClick}
                productSelection={state.treeProductSelected}
                planSelection={state.treePlanSelected}
                tagsOptions={tagsOptions}
                summaryOptions={state.allProductsObject}
                setSelectedOption={handleSearchChange}
                period={periodSelection}
                periods={periods}
                setPeriod={handlePeriodChange}
                filterStartDate={filterStartDate}
                filterEndDate={filterEndDate}
                total={totalRecords}
                showCustomDate={showCustomDate}
                showSubscriberName={showSubscriberName}
                setShowSubscriberName={setShowSubscriberName}
                calendarDates={calendarDates}
                handleCalendarSelect={handleCalendarSelect}
                calendarVisible={calendarVisible}
                getPaymentCsvWithFilters={getPaymentCsvWithFilters}
                getPaymentPdfWithFilters={getPaymentPdfWithFilters}
                fetchingPaymentCsv={fetchingPaymentCsv}
                fetchingPaymentMissedCsv={fetchingPaymentMissedCsv}
                fetchingPaymentExternalCsv={fetchingPaymentExternalCsv}
                fetchingPaymentPdf={fetchingPaymentPdf}
                fetchingPaymentMissedPdf={fetchingPaymentMissedPdf}
                fetchingPaymentExternalPdf={fetchingPaymentExternalPdf}
                colleagueListOptions={colleagueListOptions}
                externalModeFilterOptions={externalModeFilterOptions}
                {...{
                    spinnerConditions, exportItemsTemplate, dropdownExportItems,
                    state, currency, fetchingCollected, currencySymbol, currencyFormat,
                    segmentSuccess: segmentList, selectedSegment, setSelectedSegment, handleSegmentFilter, handleColleagueSelect,
                    handleExternalModeSelect, handleTagSelection, selectedTags, setNameCleared, selectedColleague,
                    setSelectedColleague, selectedColleagueOption, selectedExternalMode, setSelectedExternalMode
                }}
                state={state}
                setState={setState}
            />
            <CustomDataTable
                key={`${typeSelection.code}-${isMobileStack}`}
                columns={columns}
                loading={loading}
                responsiveLayout="stack"
                tableClassName="payments-data-table"
                value={paymentRows}
            />
            <Paginator
                className="custom-paginator payments-paginator"
                rows={totalRecords?.length === 0 ? 0 : state.size}
                totalRecords={totalRecords}
                first={state.first}
                onPageChange={onPageChange}
            />
            <OverlayPanel showCloseIcon className="subsOverlay" ref={overlayPanelMoreSubs} onHide={hideCustomerSubscriptions}>
                <div className="recover-overlay-panel">{overlayContent}</div>
            </OverlayPanel>
            <OverlayPanel ref={loadingOverlayRef} dismissable={false} closeOnEscape={false}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px', minWidth: '150px' }}>
                    <ProgressSpinner style={{ width: '15px', height: '10px' }} />
                </div>
            </OverlayPanel>
        </div>
    );
}

export default Payments;

